module.exports = __webpack_public_path__ + "static/media/Beginner.4b1240ba.svg";